module.exports = __webpack_public_path__ + "img/memberlist.64d46c70.svg";